// extracted by mini-css-extract-plugin
export default {"body":"ManufacturerTable_body__tDGw6","icon":"ManufacturerTable_icon__6bwmB","company":"ManufacturerTable_company__cuBio","notFound":"ManufacturerTable_notFound__Kstva"};